import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { StockRecommendationHomeResolver } from '../core/resolver/stock-recommendation-home.resolver';
import { MonthlyComponent } from './monthly/monthly.component';
import { WeeklyComponent } from './weekly/weekly.component';
import { YearComponent } from '../ipo-calendar/year/year.component';
import { DailyComponent } from './daily/daily.component';
import { RecommendationMonthlyResolver } from '../core/resolver/recommendation-monthly-resolver';
import { RecommendationWeeklyResolver } from '../core/resolver/recommendation-weekly-resolver';
import { RecommendationYearlyResolver } from '../core/resolver/recommendation-yearly-resolver';
import { StockRecommendationDetailResolver } from '../core/resolver/stock-recommendation-detail.resolver';
import { StockRecommendationComponent } from './stock-recommendation.component';
import { DetailComponent } from './detail/detail.component';
import { StockRecommendationBrokerageFirmResolver } from '../core/resolver/stock-recommendation-brokerage-firm-resolver';
import { StockRecommendationBrokerageFirmComponent } from './stock-recommendation-brokerage-firm/stock-recommendation-brokerage-firm.component';

const routes: Routes = [
  { path: '', component: StockRecommendationComponent ,
  children: [
    { path: 'gunluk',data: { revalidate: 30 },resolve: { suggestionMonthlyResolver: RecommendationMonthlyResolver  }, component: DailyComponent},
    { path: 'haftalik',data: { revalidate: 30 },resolve: { suggestionWeeklyResolver: RecommendationWeeklyResolver  }, component: WeeklyComponent},
    { path: 'aylik',data: { revalidate: 30 },resolve: { suggestionMonthlyResolver: RecommendationMonthlyResolver  }, component: MonthlyComponent},
    { path: 'yillik/:year',data: { revalidate: 30 },resolve: { suggestionYearlyResolver: RecommendationYearlyResolver  }, component: YearComponent}, 
    { path: 'araci-kurum/:url',data: { revalidate: 30 },resolve: { stockRecommendationBrokerageFirmResolver : StockRecommendationBrokerageFirmResolver  }, component: StockRecommendationBrokerageFirmComponent}, 
    { path: ':url',data: { revalidate: 30 },resolve: { stockRecommendationDetailResolver: StockRecommendationDetailResolver  }, component: DetailComponent},    
    { path: '',resolve: { stockRecommendationHomeResolver: StockRecommendationHomeResolver  }, component: HomeComponent}
  ] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StockRecommendationRoutingModule { }
